export default "__VITE_ASSET__DUrSXMYF__"